import { gql } from 'apollo-boost';

export const SEND_TRIAL_EXPIRY_REMINDER_MANUAL = gql`
    mutation($data: SendTrialExpiryReminderManualInput!) {
        sendTrialExpiryReminderManual(data: $data) {
            ... on SendTrialExpiryReminderManualSuccess {
                success
                message
            }
            ... on UserNotFound {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
